'use strict';

import RulesEdit from './rules.edit.ctrl';

export default angular
  .module('main.rules', [
    RulesEdit
  ])
  .name;
